import moment from 'moment';
export function getInitials(name){
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
}

export function numberWithCommas(x) {
    if(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return x;
}

export function getSecondsInTextTime(durationSeconds){
    let duration = parseInt(durationSeconds)*1000;
    let hrs, mins, sec;
    if(parseInt(durationSeconds/3600) > 0){
        hrs = parseInt(moment.utc(duration).format("HH"));
        mins = moment.utc(duration).format("mm");
        return hrs + " hrs " + mins + " mins"
    }else if(parseInt(durationSeconds/60) > 0){
        mins = moment.utc(duration).format("mm");
        if(mins < 10){
            return mins[1] + " mins";
        }
        return mins + " mins"
    }else{
        return durationSeconds + " sec";
    }
}